"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountedOrderedSet = void 0;
const hash_1 = require("./hash");
const eq_1 = require("./eq");
require("../../JSON");
function CountedOrderedSet() {
  const index = {};
  const values = [];
  const counts = [];
  const add = value => {
    var _a;
    const key = (0, hash_1.hash)(value);
    const entry = (_a = index[key]) === null || _a === void 0 ? void 0 : _a.find(x => (0, eq_1.eq)(x[0], value));
    if (entry != null) {
      const offset = entry[1];
      counts[offset] += 1;
      return offset;
    }
    const entries = index[key] || [];
    entries.push([value, values.length]);
    index[key] = entries;
    values.push(value);
    counts.push(1);
    return values.length - 1;
  };
  // We directly expose some of the internal data structures as an optimization
  // in the crunching code.
  return {
    add,
    values,
    counts
  };
}
exports.CountedOrderedSet = CountedOrderedSet;